
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/renderer.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-markdown/demo/codeDemo/renderer.md?type=demo')
};